import styled from '@emotion/styled';

type PaddingProps = {
  padding: string;
};

export const Padding = styled.div<PaddingProps>`
  padding: ${({ padding }) => padding};
`;
